import verifyPayload from "../utils/payloadVerification.js";
import { config } from "../utils/setup.js";
import { errors, logs } from "../utils/logShooter.js";
import chalk from "chalk";

/**
 * Handles error logging to Sentry and OpenSearch
 * 
 * @param {Object} errorPayload - The error payload object
 * @param {string} errorPayload.message - Error message
 * @param {string} [errorPayload.origin] - Origin of the error
 * @param {string} [errorPayload.version] - Version information
 * @param {string} [errorPayload.deviceType] - Type of device
 * @param {string} [errorPayload.path] - Path information
 * @param {number} [errorPayload.errorCode] - Error code
 * @param {string} [errorPayload.errorMessage] - Error message
 * @param {string} [errorPayload.jsonPayload] - Additional error payload data
 * @param {string} [errorPayload.source] - Source of the error
 * @param {Error} [err] - Optional Error object to capture stack trace
 * @throws {Error} If the error payload validation fails
 */
function error(err, errorPayload = {}) {
    errorPayload.severityLevel = "ERROR";
    errorPayload.jsonPayload = { err }
    errorPayload.path = (err.stack.split("\n")[1] && err.stack.split("\n")[1].split("(")[1] && err.stack.split("\n")[1].split("(")[1].split(")")[0]) || err.stack
    errorPayload = { ...errorPayload, config }
    errorPayload.message = errorPayload.message || err.message;

    const { error, payload } = verifyPayload(errorPayload);
    if (error) {
        throw new Error(error);
    }

    if (config.console) {
        if (typeof window === 'undefined') {
            console.error(chalk.black.bgRed("LOGGER: ", errorPayload.message));
        } else {
            console.log("LOGGER: ", errorPayload.message);
        }
    }

    if (config.autoOpenSearch) {
        logs.push(payload)
    }
    errors.push(payload)
}

export default error;